import { ReactNode } from 'react'
import { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
    icon: LucideIcon
    title: string
    description: string
    action?: ReactNode
}

export default function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
    return (
        <div className="glass-card py-16 text-center border-dashed border-2 border-primary/10">
            <div className="w-20 h-20 mx-auto bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <Icon className="w-10 h-10 text-secondary" />
            </div>
            <h3 className="text-xl font-black text-primary uppercase italic tracking-tighter">{title}</h3>
            <p className="premium-text mt-3 max-w-sm mx-auto">{description}</p>
            {action && <div className="mt-8">{action}</div>}
        </div>
    )
}
